import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ReferrerTraffic } from '../../types/traffic';
interface ReferrerChartProps {
  referrers: ReferrerTraffic[];
}
const axisStyle = {
  fill: 'var(--muted-foreground)',
  fontSize: 11,
  fontFamily: 'Geist Mono'
};
export function ReferrerChart({
  referrers
}: ReferrerChartProps) {
  return <div className="h-64 w-full sm:h-72" data-id="element-338" data-mp="tytzj23yqpzs">
      <ResponsiveContainer width="100%" height="100%" data-id="element-339" data-mp="u05bhp7kb41z">
        <BarChart data={referrers} layout="vertical" margin={{
        top: 4,
        right: 12,
        bottom: 0,
        left: 0
      }} data-id="element-340" data-mp="yyzvguh9myno">
          <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" horizontal={false} data-id="element-341" data-mp="k9adxoov8i18" />
          <XAxis type="number" tick={axisStyle} stroke="var(--border)" tickFormatter={value => `${Math.round(Number(value) / 1000)}k`} data-id="element-342" data-mp="p72gdcn4zmjo" />
          <YAxis type="category" dataKey="source" tick={{
          ...axisStyle,
          fontFamily: 'Geist'
        }} stroke="var(--border)" width={104} data-id="element-343" data-mp="1hqiuyrc2zuky" />
          <Tooltip cursor={{
          fill: 'var(--muted)'
        }} contentStyle={{
          background: 'var(--popover)',
          border: '1px solid var(--border)',
          borderRadius: 10,
          fontSize: 12,
          color: 'var(--popover-foreground)'
        }} formatter={(value: number) => [value.toLocaleString(), 'Requests']} data-id="element-344" data-mp="3qakmbkrv7pr8" />
          <Bar dataKey="requests" fill="var(--chart-3)" radius={[0, 4, 4, 0]} barSize={16} data-id="element-345" data-mp="ctldvabp6v1p" />
        </BarChart>
      </ResponsiveContainer>
    </div>;
}